import { render, staticRenderFns } from "./RightColumnQuizSettings.vue?vue&type=template&id=5fad8180&scoped=true"
import script from "./RightColumnQuizSettings.vue?vue&type=script&lang=js"
export * from "./RightColumnQuizSettings.vue?vue&type=script&lang=js"
import style0 from "./RightColumnQuizSettings.vue?vue&type=style&index=0&id=5fad8180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad8180",
  null
  
)

export default component.exports